import { TSpinnerProps } from './Spinner.types';
import { SSpinner } from './Spinner.styles';

const Spinner = (props: TSpinnerProps) => {
  return <SSpinner {...props} />;
};

export default Spinner;
